import { type MarketsDataSet } from '../datasets/markets';
import useAsyncImportDataSets from './useAsyncImportDataSets';

const useMarketList = () => {
    const { loading, data } = useAsyncImportDataSets('markets');

    return { loading, data: (data ?? []) as MarketsDataSet };
};

export default useMarketList;
